import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminPage = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://rea-state-anu.onrender.com/contacts'); // Replace this with your actual endpoint
        setMessages(response.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Admin Dashboard</h1>

      {/* Table for displaying messages */}
      <section>
        <h2 style={{ marginBottom: '10px' }}>Messages</h2>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  padding: '12px',
                  textAlign: 'left',
                  border: '1px solid #ddd',
                  backgroundColor: '#f4f4f4',
                }}
              >
                Name
              </th>
              <th
                style={{
                  padding: '12px',
                  textAlign: 'left',
                  border: '1px solid #ddd',
                  backgroundColor: '#f4f4f4',
                }}
              >
                Number
              </th>
              <th
                style={{
                  padding: '12px',
                  textAlign: 'left',
                  border: '1px solid #ddd',
                  backgroundColor: '#f4f4f4',
                }}
              >
                Location
              </th>
              <th
                style={{
                  padding: '12px',
                  textAlign: 'left',
                  border: '1px solid #ddd',
                  backgroundColor: '#f4f4f4',
                }}
              >
                Message
              </th>
              <th
                style={{
                  padding: '12px',
                  textAlign: 'left',
                  border: '1px solid #ddd',
                  backgroundColor: '#f4f4f4',
                }}
              >
                Created At
              </th>
            </tr>
          </thead>
          <tbody>
            {messages.map((message) => (
              <tr key={message._id}>
                <td
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                  }}
                >
                  {message.name}
                </td>
                <td
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                  }}
                >
                  {message.number}
                </td>
                <td
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                  }}
                >
                  {message.location}
                </td>
                <td
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                  }}
                >
                  {message.message}
                </td>
                <td
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                  }}
                >
                  {new Date(message.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default AdminPage;
